import { Box, Stack } from '@mui/material'
import { Link } from 'react-router-dom'
import React from 'react';
import './Navbar.css';


const Navbar = () => (
  <Box display={'flex'} justifyContent={'center'}>
  <Stack direction={'row'} sx={{ position: 'sticky', justifyContent: 'space-around', width: { sm: '100vw', md: '40vw' } }}>
    <Link to="/" className="nav">Home</Link>
    <Link to="/About" className="nav">About</Link>
    {/* <Link to="/Projects" className="nav">Projects</Link> */}
    <Link to="mailto:tmcvenatt@gmail.com" className="contact-me">Contact</Link>

  </Stack>
  </Box>
)

export default Navbar